import _ from 'lodash';
import {i18n} from '../../plugins/i18n';

export default {
  state: {
    uuid: null,
    order: null,
    photo: null,
    product: null,
    productItem: null,
    productSet: null,
    productVariantId: null,
    pricelistProductId: null,
    bulkPrice: null,
    orderStep: null,
    prevSteps: [],
    viewProduct: null,
    mass: false,
    carouselView: null,
  },
  getters: {
    UUID: state => {
      return state.uuid;
    },
    MASS: state => {
      return state.mass;
    },
    ORDER: state => {
      return state.order;
    },
    PHOTO: state => {
      return state.photo;
    },
    ORDER_STEP: state => {
      return state.orderStep;
    },
    LAST_PREV_ORDER_STEP: state => {
      return _.last(state.prevSteps);
    },
    VIEW_PRODUCT: state => {
      return state.viewProduct;
    },
    BULK_PRICE: state => {
      return state.bulkPrice;
    },
    CAROUSEL_VIEW: state => {
      return state.carouselView;
    },
    PRODUCT_SET: state => {
      return state.productSet;
    },
  },
  mutations: {
    SET_UUID: (state, payload) => {
      state.uuid = payload;
    },
    SET_MASS: (state, payload) => {
      state.mass = payload;
    },
    SET_ORDER: (state, payload) => {
      state.order = payload;
    },
    SET_PRODUCT: (state, payload) => {
      state.order.product = payload;
    },
    SET_PRODUCT_ITEM: (state, payload) => {
      state.order.productItem = payload;
    },
    SET_PRODUCT_SET: (state, payload) => {
      state.productSet = payload;
    },
    SET_PRODUCT_VARIANT_ID: (state, payload) => {
      state.order.productVariantId = payload;
    },
    SET_PRODUCT_VARIANT_NAME: (state, payload) => {
      state.order.productVariantName = payload;
    },
    SET_PRICELIST_PRODUCT_ID: (state, payload) => {
      state.order.pricelistProductId = payload;
    },
    SET_BULK_PRICE: (state, payload) => {
      state.bulkPrice = payload;
    },
    SET_PHOTO: (state, payload) => {
      state.photo = payload;
    },
    SET_PHOTOS: (state, payload) => {
      if (state.order && state.order.photos) {
        state.order.photos = payload;
      }
    },
    SET_ORDER_STEP: (state, payload) => {
      state.orderStep = payload;
    },
    ADD_PHOTO: (state, payload) => {
      state.order.photos.push(payload);
      state.order.quantity++;
    },
    REMOVE_PHOTO: (state, index) => {
      state.order.photos.splice(index, 1);
      state.order.quantity--;
    },
    ADD_PREV_ORDER_STEP: (state, payload) => {
      state.prevSteps.push(payload);
    },
    SET_PREV_ORDER_STEPS: (state, payload) => {
      state.prevSteps = payload;
    },
    REMOVE_LAST_PREV_ORDER_STEP: (state) => {
      state.prevSteps.pop();
    },
    SET_PHOTO_QUANTITY: (state, data) => {
      state.order.photos[data.index].quantity = data.quantity;
      state.order.quantity = Object.values(state.order.photos).
          reduce((previous, {quantity}) => previous + quantity, 0);
    },
    SET_VIEW_PRODUCT: (state, payload) => {
      state.viewProduct = payload;
    },
    SET_CAROUSEL_VIEW: (state, payload) => {
      state.carouselView = payload;
    },
  },
  actions: {
    INIT_ORDER: (context) => {
      context.commit('SET_ORDER', {
        product: null,
        productItem: null,
        productVariantId: null,
        pricelistProductId: null,
        bulkPriceId: null,
        photos: [],
        quantity: 0,
      });
    },
    INIT_ORDER_BY_UUID: async (context, vm) => {
      const cartAlbum = _.find(context.getters.CART.albums, {
        album_id: context.getters.ALBUM.id,
        album_hash: context.getters.ALBUM.hash,
        album_hash_password: context.getters.ALBUM.hash_password,
        album_status: context.getters.ALBUM.status,
      });

      if (cartAlbum) {
        const cartProduct = _.find(cartAlbum.products, {
          uuid: context.getters.UUID,
        });
        const product = _.find(context.getters.PRODUCTS, {
          id: cartProduct.product_category_id,
        });

        if (product && product.items) {
          const productItem = _.find(product.items, {
            id: cartProduct.product_id,
          });

          const variant = productItem && productItem.variants ? _.find(productItem.variants, {
            id: cartProduct.product_variant_id,
          }) : null;

          if (variant) {
            productItem.uuid = cartProduct.uuid;
            productItem.quantity = cartProduct.quantity;
            productItem.slug = cartProduct.slug;
            productItem.limitFrom = variant.photos_limit_from;
            productItem.limitTo = variant.photos_limit_to;

            const productVariantId = cartProduct.product_variant_id;
            const productVariantName = cartProduct.product_variant_name;
            const pricelistProductId = cartProduct.pricelist_product_id;

            const bulkPriceId = cartProduct.bulk_price_id;
            const bulkPrice = bulkPriceId ? _.find(
                _.first(_.find(productItem.variants, {
                  id: productVariantId,
                }).pricelist_product_variants).bulk_prices, {
                  id: bulkPriceId,
                }) : null;

            let quantity = 0;

            const albumItems = context.getters.ALBUM &&
            context.getters.ALBUM.album_items
                ? context.getters.ALBUM.album_items
                : null;

            if (albumItems) {
              const photos = cartProduct.photos.map((photo) => {
                let item = _.find(albumItems, {
                  id: photo.photo_id,
                });

                item.price = photo.price;
                item.quantity = photo.quantity;
                item.processing = photo.processing;
                item.filter = photo.filter;
                item.sizes = photo.sizes;

                quantity += photo.quantity;

                return item;
              });

              context.commit('ADD_PREV_ORDER_STEP',
                  `3-${productItem.slug}-more-photos`);

              context.commit('SET_ORDER', {
                product,
                productItem,
                productVariantId,
                productVariantName,
                pricelistProductId,
                bulkPriceId,
                photos,
                quantity,
              });

              context.commit('SET_BULK_PRICE', bulkPrice);
            } else {
              vm.$router.push(vm.i18nLink('cart'));
              vm.toast(null, i18n.t('messages.cannot_edit_product_anymore'), 'danger');
            }
          }
        } else {
          vm.$router.push(vm.i18nLink('cart'));
          vm.toast(null, i18n.t('messages.cannot_edit_product_anymore'), 'danger');
        }
      } else {
        vm.$router.push(vm.i18nLink('cart'));
        vm.toast(null, i18n.t('messages.cannot_edit_product_anymore'), 'danger');
      }
    },
    SET_ORDER: (context, order) => {
      context.commit('SET_ORDER', order);
    },
    SET_UUID: (context, uuid) => {
      context.commit('SET_UUID', uuid);
    },
    SET_MASS: (context, mass) => {
      context.commit('SET_MASS', mass);
    },
    SET_VIEW_PRODUCT: (context, product) => {
      context.commit('SET_VIEW_PRODUCT', product);
    },
    SET_ORDER_STEP: (context, orderStep) => {
      context.commit('SET_ORDER_STEP', orderStep);
    },
    SET_PHOTO: (context, photo) => {
      context.commit('SET_PHOTO', photo);
    },
    ADD_PHOTO: (context, photo) => {
      photo.quantity = 1;
      photo.processing = {
        filter: null, cropper: {data: null, cropBoxData: null},
      };
      context.commit('ADD_PHOTO', photo);
    },
    SET_PHOTOS: (context, photos) => {
      if (photos) {
        context.commit('SET_PHOTOS', photos.map((photo) => {
          if (photo && typeof photo.quantity === 'undefined') {
            photo.quantity = 1;

            if (!photo.processing) {
              photo.processing = {
                filter: null, cropper: {data: null, cropBoxData: null},
              };
            }
          }

          return photo;
        }));
      }
    },
    REMOVE_PHOTO: (context, id) => {
      const index = _.findIndex(context.getters.ORDER.photos, {id});
      context.commit('REMOVE_PHOTO', index);
    },
    SET_PRODUCT: (context, product) => {
      context.commit('SET_PRODUCT', product);
    },
    SET_PRODUCT_SET: (context, productSet) => {
      context.commit('SET_PRODUCT_SET', productSet);
    },
    SET_PRODUCT_ITEM: (context, productItem) => {
      let limitFrom, limitTo, variant;

      if (context.state.order.productVariantId) {
        variant = _.find(productItem.variants,
            {id: context.state.order.productVariantId});
      } else {
        variant = _.minBy(productItem.variants, 'price');
      }

      limitFrom = variant && variant.photos_limit_from
          ? variant.photos_limit_from : 0;
      limitTo = variant && variant.photos_limit_to
          ? variant.photos_limit_to : 0;

      productItem.limitFrom = +limitFrom;
      productItem.limitTo = +limitTo;

      context.commit('SET_PRODUCT_ITEM', productItem);
    },
    SET_PRODUCT_VARIANT_ID: (context, productVariantId) => {
      context.commit('SET_PRODUCT_VARIANT_ID', productVariantId);

      if (productVariantId) {
        context.commit('SET_PRODUCT_VARIANT_NAME',
            _.find(context.getters.ORDER.productItem.variants,
                {id: productVariantId}).name);
      }

      if (context.getters.ORDER.productItem) {
        context.dispatch('SET_PRODUCT_ITEM', context.getters.ORDER.productItem);
      }
    },
    SET_PRICELIST_PRODUCT_ID: (context, pricelistProductId) => {
      context.commit('SET_PRICELIST_PRODUCT_ID', pricelistProductId);
    },
    SET_BULK_PRICE: (context, bulkPrice) => {
      context.commit('SET_BULK_PRICE', bulkPrice);
    },
    ADD_PREV_ORDER_STEP: (context, prevStep) => {
      context.commit('ADD_PREV_ORDER_STEP', prevStep);
    },
    REMOVE_LAST_PREV_ORDER_STEP: (context) => {
      context.commit('REMOVE_LAST_PREV_ORDER_STEP');
    },
    DROP_ORDER: (context) => {
      context.commit('SET_UUID', null);
      context.commit('SET_MASS', false);
      context.commit('SET_PHOTO', null);
      context.commit('SET_PRODUCT_SET', null);
      context.commit('SET_ORDER_STEP', null);
      context.commit('SET_PREV_ORDER_STEPS', []);
      context.commit('SET_ORDER', {
        product: null,
        productItem: null,
        productVariantId: null,
        pricelistProductId: null,
        bulkPriceId: null,
        photos: [],
        quantity: 0,
      });
    },
    SET_PHOTO_QUANTITY: (context, data) => {
      context.commit('SET_PHOTO_QUANTITY', data);
    },
    SET_CAROUSEL_VIEW: (context, carouselView) => {
      context.commit('SET_CAROUSEL_VIEW', carouselView);
    },
  },
};